export default {
  title: 'Câștigă Puncte & Obține Recompense',
  header: {
    pickup: 'Ridicare în 5 Minute',
  },
  recommendations: {
    title: 'Recomandate',
  },
  discounts: {
    title: 'Reduceri',
    data: [
      {
        title: '+125 Puncte Extra',
        description: 'Evaluează-ne pe Google',
      },
      {
        title: '+{{amount}} Reducere',
        description: '+{{amount}} Reducere când plătești cu codul {{code}}',
      },
    ],
    button: {
      add: '+ Adaugă',
    },
  },
  rewards: {
    title: 'Recompense & Cupoane',
    balance: 'Sold',
    points: 'Puncte',
  },
};
